import format from 'date-fns/format'
import locales from '../locales'

export function getDays(language = 'en', dayFormat = 'eeeee') {
  const days = []

  for (let i = 0; i < 7; i++) {
    days.push(
      format(new Date(2021, 5, i), dayFormat, {
        locale: locales[language],
      })
    )
  }

  return days
}
